import type { UpdateFavorite } from '~/features/favorites' // FIXME: avoid importing from other features
import type { SendEventParams } from '~/shared/analytix'

import { createWatch } from 'effector'
import { model as favoritesModel } from '~/features/favorites' // FIXME: avoid importing from other features
import { SnapshotMap } from '../../general/snapshot-map'

const SNAPSHOTS_TO_KEEP = 1

type Type = 'tv' | 'vod' | 'tvshow'
export type FavoriteAddParameters = SendEventParams.FavoriteAdd & { contentType?: Type } // prettier-ignore

/**
 * SnapshotMap to store `favorite_add` event parameters with their history
 */
export const parameters = new SnapshotMap<FavoriteAddParameters>(
  SNAPSHOTS_TO_KEEP
)

//
// Update parameters
//

function fromParams(params: Omit<UpdateFavorite, 'type'> & { type: Type }) {
  parameters
    .update('contentId', String(params.id))
    .update('contentType', params.type)
    .update('contentName', params.name)
    .commit()
    .notify()
}

//
// Updates listeners
//

// on tv channel added to favorites
createWatch({
  unit: favoritesModel.favoriteTvChannelFx.done,
  fn({ params }) {
    if (params.favorite) {
      fromParams({ ...params, type: 'tv' })
    }
  },
})

// on vod added to favorites
createWatch({
  unit: favoritesModel.favoriteVodFx.done,
  fn({ params }) {
    if (params.favorite) {
      fromParams({ ...params, type: 'vod' })
    }
  },
})

// on tv show added to favorites
createWatch({
  unit: favoritesModel.favoriteTvShowFx.done,
  fn({ params }) {
    if (params.favorite) {
      fromParams({ ...params, type: 'tvshow' })
    }
  },
})
